module.exports = __webpack_public_path__ + "static/media/3.666b36d7.jpg";